<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4vs1Kk/tc-custom/9780253005960.jpg?1713387247048" alt="This image is the cover for the book Railroads of Meridian, Railroads Past and Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Railroads of Meridian, Railroads Past and Present
      </h1>
      <p class="bookDescription body article font2">
        <b>“Lively, well-written and informative . . . It will be of great interest to fans of railroads in the deep South and their motive power and operations.” —<i>Railfan &amp; Railroad</i></b><br/><br/>This generously illustrated narrative follows the evolution of dozens of separate railroads in the Meridian, Mississippi, area from the destruction of the town’s rail facilities in the 1850s through the current era of large-scale consolidation. Presently, there are only seven mega-size rail systems in the United States, three of which serve Meridian, making it an important junction on one of the nation’s four major transcontinental routes. The recent creation of a nationally prominent high-speed freight line between Meridian and Shreveport, the “Meridian Speedway,” has allowed the Union Pacific, Kansas City Southern, and Norfolk Southern railroads to offer the shortest rail route across the continent for Asia-US-Europe transportation.<br/><br/><b>“This volume [is] an excellent presentation, in addition to being a railroad history story that ends on a positive, upbeat note.” —<i>Michigan Railfan</i></b><br/><br/><b>“An excellent contribution to the history of railroads in the South. Southern railroading in general has been a chronically neglected subject.” —Herbert H. Harwood, Jr., author of <i>The Lake Shore Electric Railway Story</i></b><br/><br/><b>“Chronicles Meridian’s intriguing 155-year history as a center of railroad activity.” —<i>The Meridian Star</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Parker Lamb, David H. Bridges, David S. Price
      </h2>
      
      <p class="authorDescription body article"><P>J. Parker Lamb, Professor Emeritus at the University of Texas, is author of six books, including Perfecting the American Steam Locomotive (IUP, 2003) and Evolution of the American Diesel Locomotive (IUP, 2007).</P><P>David H. Bridges is a native of Philadelphia, Mississippi, situated 38 miles northwest of Meridian. His predominant railroad interests have focused on the line that served his hometown, the Gulf, Mobile & Northern, leading him to write extensively on its early development for the GM&O Historical Society magazine.</P><P>David S. Price, a native of Long Beach, Mississippi, is a longtime resident of Hattiesburg.  He collects photographs and historical data on sawmills and short lines as well as southern trunk lines and numerous images from prominent early southern photographers.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ac3356f6